import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {usePermissionsFailureGuard} from '../../hooks/usePermissionsFailureGuard.ts';
import {rbacActions} from "../../config/rbac/actions.ts";

export const PersonasLayout = () => {

    // Interim until FNP-1749: a failed check shows the error page, never a redirect.
    usePermissionsFailureGuard();

    const {
        allowedActions
    } = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListPersonas) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes(rbacActions.CreatePersona) ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/personas'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetPersona) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/personas'/>
                    )
                }
            />
        </Routes>
    );
};
